import { render, staticRenderFns } from "./SuccessArea.vue?vue&type=template&id=15fbe008&scoped=true&"
import script from "./SuccessArea.vue?vue&type=script&lang=js&"
export * from "./SuccessArea.vue?vue&type=script&lang=js&"
import style0 from "./SuccessArea.vue?vue&type=style&index=0&id=15fbe008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbe008",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDivider,VIcon})
